import { RacemapAPIClient } from '@racemap/utilities/api-client';
import { OneMinuteInMillis } from '@racemap/utilities/consts/time';
import type { ObjectId } from 'bson';
import useSWR, { type SWRConfiguration } from 'swr';

const apiClient = RacemapAPIClient.fromWindowLocation();

/**
 * Checks whether the given user can activate directly and provides details about the decision.
 *
 * @returns { canActivateDirectly: boolean | undefined; reason?: string; details?: string; isLoading: boolean; error: Error; mutate: () => void }
 */
export function useUserCanActivateDirectly(
  userId?: string | ObjectId | undefined | null,
  options?: SWRConfiguration,
): {
  canActivateDirectly: boolean | undefined;
  reason?: string;
  details?: string;
  isLoading: boolean;
  error: Error;
  mutate: () => void;
} {
  const { data, isLoading, error, mutate } = useSWR(
    userId ? ['GET', 'USER_CAN_ACTIVATE_DIRECTLY', userId.toString()] : null,
    async ([, , userId]) => {
      const res = await apiClient.checkIfUserCanActivateDirectly(userId);
      return res;
    },
    {
      revalidateIfStale: false,
      revalidateOnFocus: false,
      refreshInterval: OneMinuteInMillis * 5,
      staleTime: OneMinuteInMillis * 5,
      ...options,
    },
  );

  return {
    canActivateDirectly: data?.status,
    reason: data?.reason,
    details: data?.details,
    isLoading,
    error,
    mutate,
  };
}
